import { defineStore } from 'pinia'

import type { SlotsManagementStore } from './interfaces'

import { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useSlotsManagementStore = defineStore('slots-management', {
  state: (): SlotsManagementStore => ({
    saving: false,
    dayTabId: ShortDaysOfWeek.Monday,
    bookingDays: [],
    salesQueueDays: [],
  }),
  actions,
  getters,
})
